import * as env from '@/env'

if (env.mockApp) {
  window.jsBridge = {
    postMessage: (event, params) => {
      console.log('[jsBridge] postMessage', event, params)

      if (event === 'openWindow') {
        // location.href = JSON.parse(params).url
        window.open(JSON.parse(params).url, '_blank')
      }
    },
  }
}
